// navigation constants for signed out pages
const HOME = 'home',
      SEARCH = 'search',
      HOME_URL = 'home',
      HOME_DEFAULT = 'home.default',
      EXPLORE = 'explore',
      WORKSPACE = 'workspace.open',
      PROFILE = 'publicProfile';

export {
  HOME,
  SEARCH,
  HOME_URL,
  HOME_DEFAULT,
  EXPLORE,
  WORKSPACE,
  PROFILE
};
